import React from 'react';
import { useOutletContext } from 'react-router-dom';
import Profile from '../../components/Profile';

export default function ProfilePage() {
  const ctx = useOutletContext();
  return <Profile {...ctx} />;
}
